// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 1rem 2rem;
  background-color: #1E2D3D;
  color: white;
}

.logo h1 {
  font-size: 1.8rem;
  margin: 0;
  color: #9945FF; /* Solana purple color */
}

.navigation ul {
  display: flex;
  list-style: none;
  padding: 0;
  margin: 0;
}

.navigation li {
  margin-left: 1.5rem;
}

.navigation a {
  color: white;
  text-decoration: none;
  font-size: 1rem;
  transition: color 0.3s ease;
}

.navigation a:hover {
  color: #9945FF;
}

@media (max-width: 768px) {
  .header {
    flex-direction: column;
    padding: 1rem;
  }
  
  .navigation {
    margin-top: 1rem;
  }
  
  .navigation ul {
    flex-wrap: wrap;
    justify-content: center;
  }
  
  .navigation li {
    margin: 0.5rem;
  }
} `, "",{"version":3,"sources":["webpack://./src/components/Header.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,kBAAkB;EAClB,yBAAyB;EACzB,YAAY;AACd;;AAEA;EACE,iBAAiB;EACjB,SAAS;EACT,cAAc,EAAE,wBAAwB;AAC1C;;AAEA;EACE,aAAa;EACb,gBAAgB;EAChB,UAAU;EACV,SAAS;AACX;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,qBAAqB;EACrB,eAAe;EACf,2BAA2B;AAC7B;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE;IACE,sBAAsB;IACtB,aAAa;EACf;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,eAAe;IACf,uBAAuB;EACzB;;EAEA;IACE,cAAc;EAChB;AACF","sourcesContent":[".header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding: 1rem 2rem;\n  background-color: #1E2D3D;\n  color: white;\n}\n\n.logo h1 {\n  font-size: 1.8rem;\n  margin: 0;\n  color: #9945FF; /* Solana purple color */\n}\n\n.navigation ul {\n  display: flex;\n  list-style: none;\n  padding: 0;\n  margin: 0;\n}\n\n.navigation li {\n  margin-left: 1.5rem;\n}\n\n.navigation a {\n  color: white;\n  text-decoration: none;\n  font-size: 1rem;\n  transition: color 0.3s ease;\n}\n\n.navigation a:hover {\n  color: #9945FF;\n}\n\n@media (max-width: 768px) {\n  .header {\n    flex-direction: column;\n    padding: 1rem;\n  }\n  \n  .navigation {\n    margin-top: 1rem;\n  }\n  \n  .navigation ul {\n    flex-wrap: wrap;\n    justify-content: center;\n  }\n  \n  .navigation li {\n    margin: 0.5rem;\n  }\n} "],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
